import { forwardRef, useId, type InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, hint, className, id, ...rest },
  ref
) {
  const generatedId = useId();
  const inputId = id ?? generatedId;

  return (
    <div className="sarnia-field">
      {label ? (
        <label className="sarnia-field__label" htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      <input
        ref={ref}
        id={inputId}
        className={['sarnia-input', error ? 'sarnia-input--error' : '', className ?? ''].filter(Boolean).join(' ')}
        {...rest}
      />
      {hint ? <span className="sarnia-field__hint">{hint}</span> : null}
      {error ? <span className="sarnia-field__error">{error}</span> : null}
    </div>
  );
});
